import { useCallback, useEffect, useRef, useState } from 'react';
import { getTerminales } from '../services/terminalesService';

export default function useTerminales({ empresa, page, pageSize }) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const requestIdRef = useRef(0);

  const fetchTerminales = useCallback(async () => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setError(null);

    try {
      const response = await getTerminales(empresa, {
        limit: pageSize,
        offset: page * pageSize,
      });

      if (requestId !== requestIdRef.current) return;

      setData(response.data || []);
      setTotal(response.paging?.total || 0);
    } catch (err) {
      if (requestId !== requestIdRef.current) return;
      setError(err.message || 'Error al obtener las terminales');
      setData([]);
      setTotal(0);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  }, [empresa, page, pageSize]);

  useEffect(() => {
    fetchTerminales();
  }, [fetchTerminales]);

  // Actualiza una fila en memoria con el dato ya confirmado por el PATCH,
  // sin depender de un GET inmediato (la API de MP puede tardar en reflejarlo).
  const updateTerminalLocal = useCallback((id, patch) => {
    setData((prev) => prev.map((t) => (t.id === id ? { ...t, ...patch } : t)));
  }, []);

  return { data, total, loading, error, refetch: fetchTerminales, updateTerminalLocal };
}
